/**
 * Check If An Element Is Scrolled Into View
 */
function isScrolledIntoView(elem, offset) {
  var docViewTop = jQuery(window).scrollTop();
  var docViewBottom = docViewTop + jQuery(window).height();
  var elemTop = jQuery(elem).offset().top;

  if (!offset) {
    offset = 0;
  }

  return elemTop <= docViewBottom - offset;
}

(function($) {
  /* ==== HOME SLIDERS ==== */
  if ($(window).width() >= 768) {
    $('.new__slider').each(function() {
      $(this).slick({
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 300,
        fade: false,
        arrows: false,
        autoplay: true,
        infinite: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 950,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  }

  $('.events__slider').each(function() {
    $(this).slick({
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 300,
      fade: false,
      arrows: true,
      autoplay: false,
      infinite: true,
      prevArrow:
        '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22.19" height="17.187" viewBox="0 0 22.19 17.187"><g id="Groupe_539" data-name="Groupe 539" transform="translate(-805.472 -949.99)"><path id="Tracé_1364" class="line" data-name="Tracé 1364" d="M1246.728,950.335l7.838,8.249-7.838,8.249" transform="translate(-427.593 0)" fill="none" stroke-miterlimit="10" stroke-width="1" /><line id="Ligne_31" class="line" data-name="Ligne 31" x2="21.5" transform="translate(805.472 958.584)" fill="none" stroke-miterlimit="10" stroke-width="1" /></g></svg ></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22.19" height="17.187" viewBox="0 0 22.19 17.187"><g id="Groupe_539" data-name="Groupe 539" transform="translate(-805.472 -949.99)"><path id="Tracé_1364" class="line" data-name="Tracé 1364" d="M1246.728,950.335l7.838,8.249-7.838,8.249" transform="translate(-427.593 0)" fill="none" stroke-miterlimit="10" stroke-width="1" /><line id="Ligne_31" class="line" data-name="Ligne 31" x2="21.5" transform="translate(805.472 958.584)" fill="none" stroke-miterlimit="10" stroke-width="1" /></g></svg ></button>',
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  $('.team-navigation a').on('click', function(event) {
    if (this.hash !== '') {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function() {
          window.location.hash = hash;
        },
      );
    }
  });
  $('.team-navigation-select').on('change', function() {
    var hash = this.value;
    $('html, body').animate(
      {
        scrollTop: $(hash).offset().top,
      },
      800,
      function() {
        window.location.hash = hash;
      },
    );
  });
  var urlPathArr = window.location.href.split('/');
  var animation_1 = lottie.loadAnimation({
    container: document.getElementById('animation_1'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_1.json',
  });
  var animation_2 = lottie.loadAnimation({
    container: document.getElementById('animation_2'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_2.json',
  });
  var animation_3 = lottie.loadAnimation({
    container: document.getElementById('animation_3'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_3.json',
  });
  var animation_4 = lottie.loadAnimation({
    container: document.getElementById('animation_4'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_4.json',
  });
  var animation_6 = lottie.loadAnimation({
    container: document.getElementById('animation_6'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_6.json',
  });
  var animation_7 = lottie.loadAnimation({
    container: document.getElementById('animation_7'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_7.json',
  });
  var animation_8 = lottie.loadAnimation({
    container: document.getElementById('animation_8'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_8.json',
  });
  var animation_9 = lottie.loadAnimation({
    container: document.getElementById('animation_9'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_9.json',
  });
  var animation_10 = lottie.loadAnimation({
    container: document.getElementById('animation_10'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_10.json',
  });
  var animation_11 = lottie.loadAnimation({
    container: document.getElementById('animation_11'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/imedia/assets/js/anime/animation_11.json',
  });
})(jQuery);
